import { render, staticRenderFns } from "./formList.vue?vue&type=template&id=db875e00&scoped=true&"
import script from "./formList.vue?vue&type=script&lang=js&"
export * from "./formList.vue?vue&type=script&lang=js&"
import style0 from "./formList.vue?vue&type=style&index=0&id=db875e00&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db875e00",
  null
  
)

export default component.exports